import configs from "@/configs.json";

export const changeFileName = (file: File, newName: string): File => {
  return new File([file], newName, { type: file.type });
};

export const getFileExtension = (file: File): string => {
  const fileName: string = file.name;
  const fileNameParts: string[] = fileName.split(".");
  const extension: string = fileNameParts[fileNameParts.length - 1];
  return extension;
};

export const getUrlServer = (path: any): string => {
  if (!path) return "";
  if (typeof Blob !== "undefined" && path instanceof Blob) {
    return URL.createObjectURL(path);
  }
  if (typeof File !== "undefined" && path instanceof File) {
    return URL.createObjectURL(path);
  }
  if (typeof path === "object" && path !== null) {
    const fileObj = path.audioFile || path.file || path.blob || path.rawFile;
    if (typeof Blob !== "undefined" && fileObj instanceof Blob) {
      return URL.createObjectURL(fileObj);
    }
    if (typeof File !== "undefined" && fileObj instanceof File) {
      return URL.createObjectURL(fileObj);
    }
    const urlStr = path.audioUrl || path.url || path.path || path.userAudioUrl;
    if (typeof urlStr === "string") {
      return getUrlServer(urlStr);
    }
    return "";
  }
  if (typeof path !== "string") return "";
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("blob:") ||
    path.startsWith("data:")
  ) {
    return path;
  }
  return `${import.meta.env.VITE_API_BASE || configs.apiBaseDev}/${path}`;
};

export const jsonToFile = (jsonData: any, fileName = "aspect.json", mimeType = "application/json") => {
  const jsonString = JSON.stringify(jsonData, null, 2);
  const blob = new Blob([jsonString], { type: mimeType });
  const file = new File([blob], fileName, { type: mimeType });
  return file;
};
export const compressImage = async (file: File, maxKB: number): Promise<File> => {
  if (!file.type.startsWith("image/")) return file;

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        // Optional: limit max dimensions to help with compression
        const maxDimension = 1200;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = (height / width) * maxDimension;
            width = maxDimension;
          } else {
            width = (width / height) * maxDimension;
            height = maxDimension;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0, width, height);

        const quality = 0.9;
        const targetSize = maxKB * 1024;
        const outputMimeType = "image/webp";
        const newName = file.name.replace(/\.[^/.]+$/, "") + ".webp";

        const attemptCompression = (q: number) => {
          canvas.toBlob(
            (blob) => {
              if (blob) {
                if (blob.size > targetSize && q > 0.1) {
                  attemptCompression(q - 0.1);
                } else {
                  resolve(new File([blob], newName, { type: outputMimeType }));
                }
              } else {
                resolve(file);
              }
            },
            outputMimeType,
            q
          );
        };

        attemptCompression(quality);
      };
      img.onerror = () => resolve(file);
    };
    reader.onerror = () => resolve(file);
  });
};
